const TableCellButton = (props: any) => {
  return (
    <td onClick={props.handleClick} className="text-end">
      {props.children}
    </td>
  );
};

export default TableCellButton;
